import { defineStore } from 'pinia'
import { useAgencyStore } from './agency'
// import axios from 'axios'
import { useBookingStore } from './booking'
import useNavigationStore from './navigation'
import useStoresStore from './search'
import useHotelsKudenixStore from './hotels/kudenix'
import useHotelsRestelStore from './hotels/restel'
import useHotelsJuniperStore from './hotels/juniper/index'
import useTicketsKudenixStore from './tickets/kudenix/kudenix'
import useFlightStore from '@/stores/flight/santsg'
import {
  types as nodule_name,
  type_module,
  module_config
} from '@/lib/booking.js'

import kudenix from './hotels/kudenix'

export const useUserStore = defineStore('user', {
  state: () => ({
    id: '',
    name: '',
    type: '',
    configuration: {
      commission: {
        type: 'percentage',
        value: 0
      },
      availableProviders: [],
      canSeeAllVouchers: false,
      modules: {
        // KUDENIX
        'hotels-kudenix': false,
        'transfers-kudenix': false,
        'tickets-kudenix': false,
        'insurances-kudenix': false,
        // JUNIPER
        'hotels-juniper': false,
        'hotels-juniper-disney': false,
        'hotels-juniper-universal': false,
        'transfers-juniper': false,
        'tickets-juniper': false,
        // RESTEL
        'hotels-restel': false,
        // HOTELBEDS
        'hotels-hotelbeds': false,
        'tickets-hotelbeds': false,
        'transfers-hotelbeds': false,
        // FLIGHTS
        'flights-santsg-tourvisio': false,
        'white-labels': false,
        'hotels-ratehawk': false,
        distributed: {
          'disney': {
            active: false,
            name: '',
            provider: null,
            visible: false
          },
          'universal': {
            active: false,
            name: '',
            provider: null,
            visible: false
          }
        }
      }
    }
  }),

  getters: {
    providersAvailable() {
      const integratorAvailable = {
        kudenix: this.hasKudenix,
        juniper: this.hasJuniper,
        restel: this.hasRestel,
        hotelbeds: this.hasHotelbeds,
        flights: this.hasFlights,
      }
      return this.list?.filter(provider => integratorAvailable[provider.key]) || []
    },
    getModules() {
      const exclude = ['distributed', 'white-labels'] 
      const modules = []
      for(let module_index in this.configuration.modules) {
        if(exclude.includes(module_index)) continue
        const active = this.configuration.modules[ module_index ]
        modules.push({
          module: module_index,
          name: module_config?.[module_index]?.name || module_index,
          company: module_config?.[module_index]?.company,
          icon: module_config?.[module_index]?.icon,
          url: module_config?.[module_index]?.url,
          background_color: module_config?.[module_index]?.background_color,
          active
        })
      }
      return modules
    },
    hasHotels() {
      return (
        this.configuration.modules['hotels-juniper'] ||
        this.configuration.modules['hotels-kudenix'] ||
        this.configuration.modules['hotels-restel'] ||
        this.configuration.modules['hotels-hotelbeds'] || 
        this.configuration.modules['hotels-ratehawk']
      )
    },
    hasTransfers() {
      return (
        this.configuration.modules['transfers-juniper'] ||
        this.configuration.modules['transfers-kudenix'] ||
        this.configuration.modules['transfers-hotelbeds']
      )
    },
    hasTickets() {
      return (
        this.configuration.modules['tickets-juniper'] ||
        this.configuration.modules['tickets-kudenix'] ||
        this.configuration.modules['tickets-hotelbeds']
      )
    },
    hasFlights() {
      return this.configuration.modules['flights-santsg-tourvisio']
    },
    hasInsurances() {
      return this.configuration.modules['insurances-kudenix']
    },
    hasDisney() {
      return this.configuration.modules['hotels-juniper-disney']
    },
    hasUniversal() {
      return this.configuration.modules['hotels-juniper-universal']
    },
    hasKudenix() {
      return (
        this.configuration.modules['transfers-kudenix'] ||
        this.configuration.modules['hotels-kudenix'] ||
        this.configuration.modules['tickets-kudenix'] ||
        this.configuration.modules['insurances-kudenix']
      )
    },
    hasJuniper() {
      return (
        this.configuration.modules['hotels-juniper'] ||
        this.configuration.modules['hotels-juniper-disney'] ||
        this.configuration.modules['hotels-juniper-universal'] ||
        this.configuration.modules['transfers-juniper'] ||
        this.configuration.modules['tickets-juniper']
      )
    },
    hasRatehawk() {
      return this.configuration?.modules?.['hotels-ratehawk']
    },
    hasRestel() {
      return this.configuration?.modules?.['hotels-restel']
    },
    hasHotelbeds() {
      return (
        this.configuration?.modules?.['transfers-hotelbeds'] ||
        this.configuration?.modules?.['hotels-hotelbeds'] ||
        this.configuration?.modules?.['tickets-hotelbeds']
      )
    },
    hasWhiteLabels() {
      return this.configuration?.modules?.['white-labels']
    },
    isProductLoader() {
      // return ['super', 'product-loader'].includes(this.type)
      return this.type === 'product-loader'
    },
    isSuper() {
      return this.type === 'super'
    },
    searchersLink() {
      if (this.hasHotels) {
        if (this.configuration.modules['hotels-kudenix']) {
          return '/hotels/search/kudenix'
        }
        if (this.configuration.modules['hotels-juniper']) {
          return '/hotels/search/juniper'
        }
        if (this.configuration.modules['hotels-restel']) {
          return '/hotels/search/restel'
        }
        if (this.configuration.modules['hotels-hotelbeds']) {
          return '/hotels/search/hotelbeds'
        }
        if (this.configuration.modules['hotels-ratehawk']) {
          return '/hotels/search/ratehawk'
        }
      }

      if (this.hasTransfers) {
        if (this.configuration.modules['transfers-kudenix']) {
          return '/search/transfer/kudenix'
        }
        if (this.configuration.modules['transfers-juniper']) {
          return '/search/transfer/juniper'
        }
        if (this.configuration.modules['transfers-hotelbeds']) {
          return '/search/transfer/search/hotelbeds'
        }
      }

      if (this.hasTickets) {
        if (this.configuration.modules['tickets-kudenix']) {
          return '/search/tickets/kudenix'
        }
        if (this.configuration.modules['tickets-juniper']) {
          return '/search/tickets/juniper'
        }
        if (this.configuration.modules['tickets-hotelbeds']) {
          return '/search/tickets/hotelbeds'
        }
      }

      if (this.hasInsurances) {
        if (this.configuration.modules['insurances-kudenix']) {
          return '/insurances/search/kudenix'
        }
      }

      return '/hotels/search/kudenix'
    },
  },

  actions: {
    logIn(payload) {
      this.type = payload.user.type || ''
      this.id = payload.user._id || ''
      this.name = payload.user.profile.name || ''
      this.name += payload.user.profile.lastName.length ? ` ${payload.user.profile.lastName}` : ''

      this.setConfiguration(payload)

      const agency = useAgencyStore()
      agency.updateAgency(payload.agency)
      // this.updateAgency(payload.agency)
      this.resetSearchStores()
    },
    setConfiguration(payload) {
      const { user } = payload
      this.configuration.canSeeAllVouchers = user?.canSeeAllVouchers ?? false
      this.configuration.availableProviders = user?.availableProviders ?? []
      this.configuration.commission.type = user?.commission?.type ?? 'percentage'
      this.configuration.commission.value = user?.commission?.value ?? 0
      // MODULES NEW FORMAT
      this.configuration.modules['hotels-kudenix'] =
        payload?.agency?.options?.['hotels-kudenix'] ?? false
      this.configuration.modules['transfers-kudenix'] =
        payload?.agency?.options?.['transfers-kudenix'] ?? false
      this.configuration.modules['tickets-kudenix'] =
        payload?.agency?.options?.['tickets-kudenix'] ?? false
      this.configuration.modules['insurances-kudenix'] =
        payload?.agency?.options?.['insurances-kudenix'] ?? false
      // RESTEL
      this.configuration.modules['hotels-restel'] =
        payload?.agency?.options?.['hotels-restel'] ?? false
      // JUNIPER
      this.configuration.modules['hotels-juniper'] =
        payload?.agency?.options?.['hotels-juniper'] ?? false
      this.configuration.modules['hotels-juniper-disney'] =
        payload?.agency?.options?.['hotels-juniper-disney'] ?? false
      this.configuration.modules['hotels-juniper-universal'] =
        payload?.agency?.options?.['hotels-juniper-universal'] ?? false
      this.configuration.modules['transfers-juniper'] =
        payload?.agency?.options?.['transfers-juniper'] ?? false
      this.configuration.modules['tickets-juniper'] =
        payload?.agency?.options?.['tickets-juniper'] ?? false

      this.configuration.modules['hotels-hotelbeds'] =
        payload?.agency?.options?.['hotels-hotelbeds'] ?? false
      this.configuration.modules['tickets-hotelbeds'] =
        payload?.agency?.options?.['tickets-hotelbeds'] ?? false
      this.configuration.modules['transfers-hotelbeds'] =
        payload?.agency?.options?.['transfers-hotelbeds'] ?? false
      this.configuration.modules['flights-santsg-tourvisio'] =
        payload?.agency?.options?.['flights-santsg-tourvisio'] ?? false
      this.configuration.modules['white-labels'] =
        payload?.agency?.options?.['white-labels'] ?? false
      this.configuration.modules['hotels-ratehawk'] =
        payload?.agency?.options?.['hotels-ratehawk'] ?? false
    },
    hasModule(module) {
      return this.configuration?.modules?.[module] ?? false
    },
    resetSearchStores() {
      const bookingStore = useBookingStore()
      const navigationStore = useNavigationStore()
      const storeStore = useStoresStore()
      const hotelsKudenixStore = useHotelsKudenixStore()
      const hotelsRestelStore = useHotelsRestelStore()
      const hotelsJuniperStore = useHotelsJuniperStore()
      const ticketsKudenixStore = useTicketsKudenixStore()
      const flightStore = useFlightStore()

      bookingStore.$reset()
      navigationStore.$reset()
      storeStore.$reset()
      hotelsKudenixStore.$reset()
      hotelsRestelStore.$reset()
      hotelsJuniperStore.$reset()
      ticketsKudenixStore.$reset()
      flightStore.$reset()
    }
  },
  persist: true
})
